import React from "react";

type PropTypes<T> = {
  itemList: T[];
  RenderItem: React.ComponentType<T>;
};

export const ListMap = <T,>({
  itemList,
  RenderItem,
}: PropTypes<T>): React.ReactElement => {
  return (
    <>
      {itemList.map((componentProps, i) => {
        return <RenderItem key={i} {...componentProps} />;
      })}
    </>
  );
};
